import { Component } from '@angular/core';

@Component({
  selector: 'app-home12',
  templateUrl: './home12.component.html',
  styleUrls: ['./home12.component.scss']
})
export class Home12Component {}
